import React, { useContext, useEffect, useState } from 'react';
import {
  useTranslation,
  Modal,
  Icon,
  Button,
  toastify,
} from '@testsigma/atoms';
import { SessionContext } from '@contexts/session-context';
import SessionService from '@services/session.service';
import { UserService } from '@services/user.service';

const UserLimitExceeded = () => {
  const { session } = useContext(SessionContext);
  const [showLimitExceedModal, setShowLimitExceedModal] =
    useState<boolean>(false);
  const { t } = useTranslation();
  const logout = () => {
    SessionService.logout(true);
    const loginURL = `${session?.idService}/ui/login`;
    window.location.href = loginURL;
  };

  const notifyAdmin = () => {
    UserService.notifyAdminByEmail(session?.user?.id).then(() => {
      toastify(t('notification.mail.success'), {
        type: 'success',
        position: 'top-center',
        hideProgressBar: true,
      });
    });
  };

  useEffect(() => {
    if (session?.user?.status) {
      const isActive = ['Pending', 'Active'].includes(session?.user?.status);
      if (!isActive) {
        setShowLimitExceedModal(true);
      }
    }
  }, [session]);

  return (
    <Modal isOpen={showLimitExceedModal} className='w-[600px]'>
      <div className='flex flex-col items-start'>
        <div className=' h-12 w-12 mb-5 rounded-full border-spacing-2.5 bg-warning-50 flex items-center justify-center'>
          <Icon
            name='warning'
            className='flex text-2xl text-warning-600 p-1 bg-warning-100 rounded-full'
          ></Icon>
        </div>
        <div className='text-neutral-700 flex flex-col'>
          <h1 className='text-lg text-secondary-unique-600 font-semibold mb-2'>
            {t('user.limit_exceeded_popup_heading')}
          </h1>
          <div className='text-sm text-secondary-500 font-normal mb-3'>
            {t('user.limit_exceeded_popup_content')}
          </div>
          <div className='text-sm text-secondary-500 font-normal mb-6'>
            {t('user.limit_exceeded_popup_mail', {
              adminMail: session?.tenant?.registeredEmail,
            })}
          </div>
          <div className='flex flex-row'>
            <Button className='mr-3' type='primary' onClick={() => logout()}>
              {t('left.nav.logout')}
            </Button>

            <Button type='primary' onClick={() => notifyAdmin()}>
              {t('notify.admin')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UserLimitExceeded;
